import { useLocation } from 'react-router'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Element } from '../../../common/html/element'
import { SelectCurrencyUnit } from '../../../common/selectCurrencyUnit'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { COMPONENTS } from '../../../routers/constants'
import classes from './index.module.scss'

export const StickyBar = ({ renderLeftBar, hasCurrencyUnit }) => {
  const location = useLocation()
  const settingParams = useSettingParams()

  const currencyUnitScreen =
    location?.pathname === COMPONENTS.portfolioInsights.components.finance.route
      ? SCREEN.PORTFOLIO_INSIGHTS_FINANCE
      : SCREEN.PORTFOLIO_INSIGHTS

  const isFixedCurrency =
    settingParams && !!settingParams.bussinessSizeIds.length

  return (
    <Element
      className={classes.container}
      style={{ color: '#3A414B', borderBottomColor: '#e5e5e8' }}
    >
      <div>{renderLeftBar && renderLeftBar()}</div>
      <div>
        {hasCurrencyUnit && (
          <SelectCurrencyUnit
            screen={currencyUnitScreen}
            fixedCurrency={isFixedCurrency ? settingParams.currency : undefined}
          />
        )}
      </div>
    </Element>
  )
}
